export default function Footer() {
  return (
    <footer className="bg-slate-900/80 border-t border-slate-800 relative overflow-hidden">
      <div className="absolute inset-0 pointer-events-none">
        <div className="lumid-particle w-1 h-1 top-1/4 left-1/3 animation-delay-200 opacity-20"></div>
        <div className="lumid-particle w-1.5 h-1.5 bottom-1/3 right-1/4 animation-delay-800 opacity-15"></div>
        <div className="lumid-particle w-1 h-1 top-2/3 left-1/6 animation-delay-1500 opacity-25"></div>
      </div>

      <div className="relative z-10 max-w-5xl mx-auto px-6 sm:px-8 lg:px-12 py-12">
        <div className="grid md:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="md:col-span-1">
            <div className="flex items-center mb-4 group cursor-pointer">
              <span className="font-artistic text-base font-medium text-white group-hover:lumid-text-shine transition-all duration-300">LUMID</span>
            </div>
            <div className="flex space-x-3">
              <a href="#" className="w-7 h-7 lumid-border rounded-lg flex items-center justify-center text-slate-400 hover:text-slate-300 transition-all duration-300 cursor-pointer">
                <i className="ri-twitter-x-line text-xs"></i>
              </a>
              <a href="#" className="w-7 h-7 lumid-border rounded-lg flex items-center justify-center text-slate-400 hover:text-slate-300 transition-all duration-300 cursor-pointer">
                <i className="ri-linkedin-line text-xs"></i>
              </a>
              <a href="#" className="w-7 h-7 lumid-border rounded-lg flex items-center justify-center text-slate-400 hover:text-slate-300 transition-all duration-300 cursor-pointer">
                <i className="ri-github-line text-xs"></i>
              </a>
            </div>
          </div>

          {/* Solutions */}
          <div>
            <h3 className="text-sm font-medium text-white mb-3">Solutions</h3>
            <ul className="space-y-2">
              <li>
                <a href="https://lumilake.ai" target="_blank" rel="noopener noreferrer" className="text-xs text-gray-400 hover:text-slate-300 transition-colors duration-300 cursor-pointer font-light">
                  Lumilake
                </a>
              </li>
              <li>
                <a href="https://xp.io" target="_blank" rel="noopener noreferrer" className="text-xs text-gray-400 hover:text-slate-300 transition-colors duration-300 cursor-pointer font-light">
                  xp.io
                </a>
              </li>
            </ul>
          </div>

          {/* Use Cases */}
          <div>
            <h3 className="text-sm font-medium text-white mb-3">Use Cases</h3>
            <ul className="space-y-2">
              <li>
                <a href="https://lumid.market" target="_blank" rel="noopener noreferrer" className="text-xs text-gray-400 hover:text-slate-300 transition-colors duration-300 cursor-pointer font-light">
                  lumid.market
                </a>
              </li>
              <li>
                <a href="https://lumid.science" target="_blank" rel="noopener noreferrer" className="text-xs text-gray-400 hover:text-slate-300 transition-colors duration-300 cursor-pointer font-light">
                  lumid.science
                </a>
              </li>
            </ul>
          </div>

          {/* Company */}
          <div>
            <h3 className="text-sm font-medium text-white mb-3">Company</h3>
            <ul className="space-y-2">
              <li>
                <a href="#" className="text-xs text-gray-400 hover:text-slate-300 transition-colors duration-300 cursor-pointer font-light">
                  About
                </a>
              </li>
              <li>
                <a href="#" className="text-xs text-gray-400 hover:text-slate-300 transition-colors duration-300 cursor-pointer font-light">
                  Careers
                </a>
              </li>
              <li>
                <a href="#" className="text-xs text-gray-400 hover:text-slate-300 transition-colors duration-300 cursor-pointer font-light">
                  Contact
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="border-t border-slate-800 mt-8 pt-6 flex flex-col sm:flex-row justify-between items-center">
          <p className="text-xs text-gray-500 font-light">
            © 2026 LUMID. All rights reserved.
          </p>
          <div className="flex space-x-4 mt-3 sm:mt-0">
            <a href="#" className="text-xs text-gray-500 hover:text-gray-400 transition-colors duration-300 cursor-pointer">Privacy</a>
            <a href="#" className="text-xs text-gray-500 hover:text-gray-400 transition-colors duration-300 cursor-pointer">Terms</a>
          </div>
        </div>
      </div>
    </footer>
  );
}